module.exports = __webpack_public_path__ + "static/media/logout.a4f903b8.svg";